<template>
   <v-app>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Signup</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-alert :value="alert.show" dense outlined :type="alert.type" :icon="alert.icon">{{ alert.message }}</v-alert>
                <v-form ref="signupForm" v-model="dialogValid" lazy-validation>
                  <v-text-field id="email" label="Email" name="email" prepend-icon="email" type="text" v-model="user.email" autocomplete="username" :rules="[...getRlDialogRules.required, ...getRlDialogRules.email, ...getRlDialogRules.stringMax100]" counter="100" maxlength="100" :error-messages="alert.errors.email" @focus="emailFocused()"/>
                  <v-text-field id="name" label="Name" name="name" prepend-icon="person" type="text" v-model="user.name" autocomplete="off" :rules="[...getRlDialogRules.stringMax100, ...requiredRules]" counter="100" maxlength="100" />
                  <v-text-field id="jobTitle" label="Job Title" name="name" prepend-icon="work" type="text" v-model="user.job_title" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...requiredRules]" counter="20" maxlength="20" />
                  <v-text-field id="telephoneNumber" label="Telephone Number" name="telephoneNumber" prepend-icon="phone" type="phone" v-model="user.tel" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...requiredRules]" counter="20" maxlength="20" />
                  <v-text-field id="companyName" label="Company Name" name="companyName" prepend-icon="business" type="text" v-model="user.company_name" autocomplete="off" :rules="[...getRlDialogRules.stringMax50, ...requiredRules]" counter="50" maxlength="50" />
                  <v-text-field id="companyAddress" label="Company Address" name="companyAddress" prepend-icon="business" type="text" v-model="user.company_address" autocomplete="off" :rules="[...getRlDialogRules.stringMax50, ...requiredRules]" counter="50" maxlength="50" />
                  <v-text-field id="companyPostcode" label="Company Postcode" name="companyPostcode" prepend-icon="business" type="text" v-model="user.company_postcode" autocomplete="off" :rules="[...getRlDialogRules.stringMax20, ...requiredRules]" counter="20" maxlength="20" />
                  <v-text-field id="password" label="Password" name="password" prepend-icon="lock" type="password" v-model="user.password" autocomplete="new-password" :rules="passwordRules" maxlength="30" />
                  <v-text-field id="password_conf" label="Password Confirmation" name="password" prepend-icon="lock" type="password" v-model="user.password_confirmation" :rules="passwordConfRules" maxlength="30" />
                  <v-switch v-model="user.terms_n_conditions" @change="termsChanged" :rules="[...getRlDialogRules.boolean1]" :error-messages="alert.errors.terms_n_conditions" >
                    <template v-slot:label><span>Accept <a :class="termsURLColor" @click.stop.prevent="showTermsDialog = true">Terms and Conditions</a></span></template>
                  </v-switch>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" @click.prevent="login()"><v-icon>navigate_before</v-icon>Log in</v-btn>
                <v-spacer />
                <v-btn color="primary" @click.prevent="signup()" :disabled="!dialogValid">Sign up<v-icon>navigate_next</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-overlay :value="dialogLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <terms-dialog v-model="showTermsDialog" />
    </v-content>
   </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import termsDialog from '../components/terms/terms.vue'

export default {
  name: 'Signup',
  components: {
		termsDialog
	},
  data() {
    return {
      user: {
        email: null,
        name: null,
        job_title: null,
        tel: null,
        company_name: null,
        company_address: null,
        company_postcode: null,
        password: null,
        password_confirmation: null,
        gdpr: false,
        terms_n_conditions: false
      },  
      alert: {show: false, type: null, icon: null, message: null, errors: {}},
      dialogLoading: false,
      dialogValid: true,
      requiredRules: [
        v => !!v || 'Required',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v || '').length >= 8 || 'Minimum 8 characters',
        v => (v || '').length <= 30 || 'Maximum 30 characters'
      ],
      passwordConfRules: [
        v => !!v || 'Password confirmation is required',
        v => v === this.user.password || 'Password confirmation must match Password'
      ],
      showTermsDialog: false,
      termsURLColor: 'primary--text font-weight-bold'
    }
  },
  methods: {
    login() {
      this.$router.push('/login');
    },
    async signup() {
      try {
        if(this.$refs.signupForm.validate()) {
          this.dialogLoading = true

          await axios.get('sanctum/csrf-cookie')
          await axios.post('api/v1/auth/register', this.user)
          this.$router.push('/login')
 
          this.dialogLoading = false
          this.setShowVerificationMessage(true)
        }
      } catch (error) {
        this.dialogLoading = false
        this.alert = { show: true, type: "error", icon: "error", message: error.response.data.message, errors: error.response.data.errors}
      }
    },
    emailFocused() {   
      if(this.alert.errors.email) {
        this.alert.errors.email = null
      }
    },
    termsChanged() {
      if (this.user.terms_n_conditions === true) {
        this.user.gdpr = true
        this.termsURLColor = 'primary--text font-weight-bold'
      } else {
        this.user.gdpr = false
        this.termsURLColor = 'red--text font-weight-bold'
      }
    },
    ...mapActions([
      'setShowVerificationMessage'
    ])
  },
  computed: {
    ...mapGetters([
      'getRlDialogRules'
		])
  }
}
</script>